// src/redux/slices/cart.ts
import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface CartState {
    count: number;
    cartId: number;
    status: 'idle' | 'loading' | 'error';
}

const initialState: CartState = {
    count: 0,
    cartId: 2,
    status: 'idle'
};

const cartSlice = createSlice({
    name: 'cart',
    initialState,
    reducers: {
        setCartCount(state, action: PayloadAction<number>) {
            state.count = action.payload;
        },
        incrementCartCount(state, action: PayloadAction<number>) {
            state.count += action.payload;
        },
        decrementCartCount(state, action: PayloadAction<number>) {
            state.count = Math.max(0, state.count - action.payload);
        },
        clearCartCount(state) {
            state.count = 0;
        },
        setCartId(state, action: PayloadAction<number>) {
            state.cartId = action.payload;
        }
    }
});

export const { setCartCount, incrementCartCount, decrementCartCount, clearCartCount, setCartId } = cartSlice.actions;

export const selectCartCount = (state: any) => state.cart.count;
export const selectCartId = (state: any) => state.cart.cartId;

export default cartSlice.reducer;
